export const APP_BAR_HEIGHT_IN_PIXELS = 74;
